$(document).ready(function() {
  $('.trustSection__slider').slick({
    autoplay: true,
    infinite: true,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 590,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
